export const GET_HOME_BANNERS = "GET_HOME_BANNERS"
export const GET_EXCLUSIVE_BADGE = "GET_EXCLUSIVE_BADGE"
